import { PrivacyBanner } from '@envato/browser-privacy-checker'
import get from 'lodash-es/get'
import * as queryString from 'query-string'
import * as React from 'react'
import { renderRoutes } from 'react-router-config'

import { getCurrentSiteDomain } from '../../common/utils/sites'
import siteConfigs from '../../config/sites'
import OldIE from '../../server/template/oldIE'
import { IRouteConfig } from '../../typings/routes'
import AlertsStreamContainer from '../components/alerts/alertsStreamContainer'
import TCBannerContainer from '../components/banners/tcBanner/tcBannerContainer'
import CrossSellLinksFooter from '../components/crossSellLinksFooter'
import Modal from '../components/modals'
import PrivacyNoticeBanner from '../components/privacyNoticeBanner'
import QuickLinksFooter from '../components/quickLinksFooter/quickLinksFooter'
import SiteMeta from '../components/siteMeta/siteMetaContainer'
import { Props } from '../containers/appContainer'
import NotFoundPageContainer from '../containers/notFoundPageContainer'
import SiteFooterContainer from '../containers/siteFooterContainer'
import SiteHeaderContainer from '../containers/siteHeaderContainer'
import SearchOfflinePage from './searchOfflinePage'

class App extends React.Component<Props> {
  public render() {
    const {
      stats,
      currentSite,
      seoMeta,
      location,
      baseUrl,
      noIndex,
      canonicalPath,
      isModalOpen,
      closeModal,
      openModalType,
      openModalData,
      openModal,
      route
    } = this.props
    // add query back to location object
    // TODO: fetch from redux store instead of `withRouter`
    location.query = queryString.parse(location.search)

    const transformedRoute = route as IRouteConfig

    return (
      <div className="page">
        <OldIE siteName={currentSite} />
        <PrivacyBanner>
          <PrivacyNoticeBanner />
        </PrivacyBanner>
        <SiteMeta
          seoMeta={seoMeta}
          location={location}
          currentSite={currentSite}
          noIndex={noIndex}
          baseUrl={baseUrl}
          canonicalPath={canonicalPath}
        />

        <Modal
          openModal={openModal}
          closeModal={closeModal}
          isModalOpen={isModalOpen}
          openModalType={openModalType}
          openModalData={openModalData}
        />

        <div className="page__canvas">
          <div className="canvas">
            <SiteHeaderContainer
              routes={transformedRoute && transformedRoute.routes}
            />
            <TCBannerContainer />
            <AlertsStreamContainer />
            {this.renderContent()}
            <CrossSellLinksFooter currentSite={currentSite} />
            <QuickLinksFooter currentSite={currentSite} />
            <SiteFooterContainer stats={stats} />
          </div>
        </div>
      </div>
    )
  }

  private renderContent() {
    const { errorPage, location, currentSite, route } = this.props

    // add query back to location object
    location.query = queryString.parse(location.search)

    const popularFilesUrl = `//${getCurrentSiteDomain(
      currentSite
    )}/page/top_sellers`
    const siteDisplayName =
      get(siteConfigs, `${currentSite}.name`) || currentSite

    if (route) {
      switch (errorPage) {
        case 'NotFoundContainer':
          return <NotFoundPageContainer location={location} />

        case 'SearchOffline':
          return (
            <SearchOfflinePage
              popularFilesUrl={popularFilesUrl}
              siteDisplayName={siteDisplayName}
            />
          )

        default:
          return renderRoutes(route.routes)
      }
    } else {
      return <NotFoundPageContainer location={location} />
    }
  }
}

export default App
